import { render, staticRenderFns } from "./tv-zender-ontvangen.vue?vue&type=template&id=4357fa96"
import script from "./tv-zender-ontvangen.vue?vue&type=script&lang=js"
export * from "./tv-zender-ontvangen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports